import React from 'react';
import TocPage from './generic/TocPage';
import getLegalLinks from './Legal/getLegalLinks';

import m2492985 from'../media/ift/InternetAl/01 ON INTERNET ALÁMBRICO 30.pdf';
import m2493044 from'../media/ift/InternetAl/02  ON INTERNET ALÁMBRICO 80.pdf';
import m2493056 from'../media/ift/InternetAl/03 ON INTERNET ALÁMBRICO 100.pdf';
import m2493063 from'../media/ift/InternetAl/04 ON INTERNET ALÁMBRICO 350.pdf';
import m2493069 from'../media/ift/InternetAl/05 ON INTERNET ALÁMBRICO 750.pdf';

import m2493085 from'../media/ift/InternetAlF/01 ON INTERNET ALÁMBRICO 30 FRANJA FRONTERIZA.pdf';
import m2493180 from'../media/ift/InternetAlF/02 ON INTERNET ALÁMBRICO 80 FRANJA FRONTERIZA.pdf';
import m2493193 from'../media/ift/InternetAlF/03 ON INTERNET ALÁMBRICO 100 FRANJA FRONTERIZA.pdf';
import m2493201 from'../media/ift/InternetAlF/04 ON INTERNET ALÁMBRICO 350 FRANJA FRONTERIZA.pdf';
import m2493207 from'../media/ift/InternetAlF/05 ON INTERNET ALÁMBRICO 750 FRANJA FRONTERIZA.pdf';




const Rates = props =>
{
    return (
        <div id='rates' className='container p-4'>
            <TocPage history={props.history} links={getLegalLinks()}>
                <h4 className='mb-4'>REGISTRO DE TARIFAS ANTE IFT</h4>

              

                <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>
                        
                    </thead>
                    <tbody>
                         <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON ALÁMBRICO: INTERNET</th>
                        </tr> 
                        <tr className='thead-dark'>
                             <th className='td-title'>NOMBRE</th>
                            <th className='td-title'>TARIFA</th>
                        </tr>
                        <tr>
                            <td>ON INTERNET ALÁMBRICO 30</td>
                            <td><a href={m2492985} target='_blank' rel='noopener noreferrer'>2492985</a></td>
                        </tr>
                        <tr>
                            <td>ON INTERNET ALÁMBRICO 80</td>
                            <td><a href={m2493044} target='_blank' rel='noopener noreferrer'>2493044</a></td>
                        </tr>
                        <tr>
                            <td>ON INTERNET ALÁMBRICO 100</td>
                            <td><a href={m2493056} target='_blank' rel='noopener noreferrer'>2493056</a></td>
                        </tr>
                        <tr>
                            <td>ON INTERNET ALÁMBRICO 350</td>
                            <td><a href={m2493063} target='_blank' rel='noopener noreferrer'>2493063</a></td>
                        </tr>
                        <tr>
                            <td>ON INTERNET ALÁMBRICO 750</td>
                            <td><a href={m2493069} target='_blank' rel='noopener noreferrer'>2493069</a></td>
                        </tr>
                        
                        

                    </tbody>
                </table>

                <table className='table table-striped table-bordered'>
                    <thead className='thead-dark'>
                        
                    </thead>
                    <tbody>
                        
                        <tr className='thead-dark'>
                             <th className='td-title' colspan="2">ON ALÁMBRICO: INTERNET IVA FRONTERIZO</th>
                        </tr>
                        <tr className='thead-dark'>
                           <th className='td-title'>NOMBRE</th>
                            <th className='td-title'>TARIFA</th>
                        </tr>
                        <tr>
                            <td>ON INTERNET ALÁMBRICO 30</td>
                            <td><a href={m2493085} target='_blank' rel='noopener noreferrer'>2493085</a></td>
                        </tr>
                        <tr>
                            <td>ON INTERNET ALÁMBRICO 80</td>
                            <td><a href={m2493180} target='_blank' rel='noopener noreferrer'>2493180</a></td>
                        </tr>
                        <tr>
                            <td>ON INTERNET ALÁMBRICO 100</td>
                            <td><a href={m2493193} target='_blank' rel='noopener noreferrer'>2493193</a></td>
                        </tr>
                        <tr>
                            <td>ON INTERNET ALÁMBRICO 350</td>
                            <td><a href={m2493201} target='_blank' rel='noopener noreferrer'>2493201</a></td>
                        </tr>
                        <tr>
                            <td>ON INTERNET ALÁMBRICO 750</td>
                            <td><a href={m2493207} target='_blank' rel='noopener noreferrer'>2493207</a></td>
                        </tr>
                       


                    </tbody>
                </table>



                <p>Las tarifas ante señaladas pueden consultarse en el Registro Público de Concesiones, publicado en la página electrónica del Instituto Federal de Telecomunicaciones</p>
            </TocPage>
        </div>
    );
}

export default Rates;



// WEBPACK FOOTER //
// ./src/components/Rates_an.js